module.exports = __webpack_public_path__ + "static/media/background-task-logo.5b83587b.png";